import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "universal-card__inner-wrapper" }
const _hoisted_2 = { class: "universal-card__header" }
const _hoisted_3 = { class: "universal-card__title-container" }
const _hoisted_4 = { class: "universal-card__title" }
const _hoisted_5 = { class: "universal-card__on-air" }
const _hoisted_6 = { class: "universal-card__content" }
const _hoisted_7 = { class: "universal-card__data-tags" }
const _hoisted_8 = { class: "universal-card__action-buttons" }


import onAir from '../on-air/on-air.vue';
import dataTag from '../data-tag/data-tag.vue';
import customButton from '../custom-button/custom-button.vue';
import { IUniversalCardProps } from './universal-card.types';
import MaterialShapedIcon from '../../helper-components/material-shape-container/material-shaped-icon/material-shaped-icon.vue';
import router from '@/router';


export default /*#__PURE__*/_defineComponent({
  __name: 'universal-card',
  props: {
    props: null
  },
  setup(__props: any) {



const NavigateToAddress = (address: string) => {
    router.push(address);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["universal-card", {
            'material-card_type_elevated': __props.props.type === 'elevated',
            'material-card_type_elevated-secondary':
                __props.props.type === 'elevated-secondary',
            'material-card_type_outlined': __props.props.type === 'outlined',
            'material-card_type_filled': __props.props.type === 'filled',
        }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          (__props.props.icon)
            ? (_openBlock(), _createBlock(MaterialShapedIcon, {
                key: 0,
                class: "universal-card__title-icon sn-msc-on-universal-card",
                props: {
                            color: '',
                            shape: 'eight-pointed-shape',
                            iconCompleteUrl: __props.props.icon,
                        }
              }, null, 8, ["props"]))
            : _createCommentVNode("", true),
          _createElementVNode("h2", _hoisted_4, _toDisplayString(__props.props.title), 1)
        ]),
        _createElementVNode("div", _hoisted_5, [
          (__props.props.isOnAir)
            ? (_openBlock(), _createBlock(onAir, { key: 0 }))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_6, _toDisplayString(__props.props.content), 1),
      _createElementVNode("div", _hoisted_7, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.props.dataTags, (tagProps, index) => {
          return (_openBlock(), _createBlock(dataTag, {
            key: index,
            props: {
                        ...tagProps,
                    }
          }, null, 8, ["props"]))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_8, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.props.buttons, (button, index) => {
          return (_openBlock(), _createBlock(customButton, {
            key: index,
            props: {
                        ...button,
                    },
            onClick: ($event: any) => (
                        button.redirectToOnClick
                            ? NavigateToAddress(button.redirectToOnClick)
                            : ''
                    )
          }, null, 8, ["props", "onClick"]))
        }), 128))
      ])
    ])
  ], 2))
}
}

})